import React from 'react';
export function TopStrip() {
  return <div className="w-full bg-brand-hunter text-brand-bone border-b border-brand-charcoal/20" data-id="element-146">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5" data-id="element-147">
        <p className="text-[13px] leading-snug text-center md:whitespace-nowrap md:overflow-hidden md:text-ellipsis" data-id="element-148">
          Lake Benton, Minnesota's destination firearms and sporting goods store
          with 5,000+ guns on hand, plus ammunition and optics.
        </p>
      </div>
    </div>;
}